import React, { useState } from 'react';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { SeasonPassFieldLabel } from '../../SeasonPassFieldLabel.js';
import { getCurrentLanguageTexts } from '../../../../constants/seasonPassPersonalInfoLangs.js';

import '../SeasonPassPersonalInfo.sass';

const MySwal = withReactContent(swal);

export const FillCustomData = ({
  event,
  createOrder,
  isDisabled = false,
}) => {
  const { transactionFields } = event;

  const [fields, setFields] = useState({});
  const [isLoading, setLoading] = useState(false);

  const handleChangeField = (name, value) => {
    setFields((prev) => ({ ...prev, [name]: value }));
  };
  const txt = getCurrentLanguageTexts();

  const confirmHandler = () => {
    setLoading(true);
    createOrder(fields);
  };

  return (
    <section className='fill-custom-data-modal'>
      <h2 className='fill-custom-data-modal__title first-title'>
        {txt.memberEventsList.additionalInfo}
      </h2>

      <div className='buy-ticket-modal__fields-container'>
        {transactionFields.map((ft) => {
          if (ft.type === 0) {
            return (
              <SeasonPassFieldLabel
                label={ft.name}
                isRequired={ft.isRequired && !fields[ft.name]}
                className='partizan-open-selling__fields-label'
                shouldWrapInLabel={false}
              >
                <input
                  className='seasonpass__field-input'
                  name={ft.name}
                  placeholder={ft.name}
                  onChange={(e) => handleChangeField(ft.name, e.target.value)}
                  type='text'
                  value={fields[ft.name] || ''}
                />
              </SeasonPassFieldLabel>
            );
          } else {
            return null;
          }
        })}
      </div>

      <div className='swal2-actions'>
        <button
          className='swal2-cancel swal2-styled'
          onClick={() => MySwal.close()}
        >
          {txt.generalTxt.cancel}
        </button>
        <button
          disabled={
            !transactionFields.every((ft) => {
              if (ft.type === 0 && ft.isRequired) {
                return !!fields[ft.name];
              }

              return true;
            }) || isLoading || isDisabled
          }
          className='swal2-confirm swal2-styled'
          onClick={confirmHandler}
        >
          {txt.generalTxt.buy}
        </button>
      </div>
    </section>
  );
};
